import React, { useEffect, useLayoutEffect, useState } from "react";
import Input from "./Input";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import { generateMenu } from "../../utils/MenuGenerator";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/style.css";
import { cn, ImgIcon } from "../../utils/utils";
import useOutsideClick from "../../hooks/useOutsideClick";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import ReactDOM from "react-dom";

import { useDispatch } from "react-redux";
import { toggleDateInputPortal } from "../../lib/redux/slices/controlSlice";

import Select from "react-select";

type Props = {
  field: any;
  name: string;
  isDisabled?: boolean;
  label?: string;
  isRequired?: boolean;
  min?: string;
  title?: string;
  max?: string;
  customClass?: string;
  customLabelClass?: string;
  placeHolder?: string;
  dropDownClass?: string;
  handleChangeEvent?: any;
  value?: string | null;
  dateInputProps?: any;
  openModel: boolean;
  setOpenModel: any;
  onClickAction?: any;
  footerOptions?:{
    activatedToday?:boolean
    activaredClear?:boolean
    onClear?:any
    onReset?:any
    hasCustomFooter?:boolean
    customFooter?:any
  }
};

const Footer = ({
  handleChangeEvent,
  name,
  formatDate,
  onClickAction,
  setOpenModel,
  footerOptions
}: any) => {
  console.log(footerOptions);
  
  const FooterOptions ={
    activatedToday:true,
    activaredClear:true,
    onClear:()=>{},
    onReset:()=>{},
    hasCustomFooter:false,
    ...footerOptions
  }
  
  const dispatch = useDispatch();
  return (
    <div className="flex justify-between items-center px-2 py-2 text-base font-normal">
      <p
        className={cn("text-gray-300",FooterOptions.activaredClear ? "cursor-pointer":"cursor-not-allowed")}
        onClick={() => {
          if(!FooterOptions.activaredClear) return
          FooterOptions.onClear?.()
          onClickAction?.();
          //@ts-ignore
          //  dispatch(toggleDateInputPortal(false))
          setOpenModel(false);
          handleChangeEvent("", name);
        }}
      >
        Clear
      </p>
      <p
        className="text-primary"
        onClick={() => {
          if(!FooterOptions.activatedToday) return
          FooterOptions.onReset?.()
          onClickAction?.();
          //@ts-ignore
          // dispatch(toggleDateInputPortal(false))
          setOpenModel(false);
          handleChangeEvent(formatDate(new Date()), name);
        }}
      >
        Today
      </p>
    </div>
  );
};
function CustomMonthsDropdown(props: any) {
  const { value, onChange, options } = props;

  return (
    <div>
      <Select
        options={options || []}
        value={options?.find((opt: any) => opt.value === value) || null}
        onChange={(selected) => {
          if (!selected || !onChange) return;

          const syntheticEvent = {
            target: { value: selected.value },
          } as React.ChangeEvent<HTMLSelectElement>;

          onChange(syntheticEvent);
        }}
        isSearchable={false}
        menuPlacement="auto"
        styles={{
          control: (base) => ({
            ...base,
            border: "none",
            boxShadow: "none",
            minHeight: "28px",
            height: "28px",
            width: "auto",
            display: "inline-flex",
            minWidth: "unset",
          }),
          container: (base) => ({
            ...base,
            width: "auto",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "4px 4px",
            margin: 0,
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: "0 4px",
            margin: 0,
          }),
          indicatorSeparator: () => ({
            display: "none",
          }),
          menu: (base) => ({
            ...base,
            minWidth: "150px", // 🔹 wider dropdown menu
            zIndex: 10000,
          }),
        }}
      />
    </div>
  );
}
function CustomYearsDropdown(props: any) {
  const { value, onChange, options } = props;
  console.log(props);
  return (
    <div style={{ minWidth: 100 }}>
      <Select
        options={options || []}
        value={options?.find((opt: any) => opt.value === value) || null}
        onChange={(selected) => {
          if (onChange) {
            const syntheticEvent = {
              target: {
                value: selected?.value,
              },
            } as React.ChangeEvent<HTMLSelectElement>;

            onChange(syntheticEvent);
          }
        }}
        isSearchable
        menuPlacement="auto"
        styles={{
          control: (base) => ({
            ...base,
            border: "none",
            boxShadow: "none",
            minHeight: "28px",
            height: "28px",
            width: "auto",
            display: "inline-flex",

            minWidth: "unset",
          }),

          container: (base) => ({
            ...base,
            width: "auto",
          }),

          valueContainer: (base) => ({
            ...base,
            padding: 0,
            margin: 0,
          }),

          dropdownIndicator: (base) => ({
            ...base,
            padding: 0,
            margin: 0,
          }),

          indicatorSeparator: () => ({
            display: "none",
          }),
        }}
      />
    </div>
  );
}

function SingleDate({
  field,
  name,
  isDisabled,
  value,
  label,
  isRequired = false,
  min,
  dropDownClass,
  max,
  openModel,
  customClass,
  customLabelClass,
  setOpenModel,
  handleChangeEvent,
  dateInputProps,
  title,
  placeHolder,
  onClickAction,
  footerOptions
}: Props) {
  console.log(footerOptions);
   console.log(dateInputProps);
   
  const formatDate = (date: Date) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    //@ts-ignore
    return date.toLocaleDateString("en-GB", options); // e.g., "1 Jan 2025"
  };
  const handleDisabledState = () => {
    if (isDisabled) {
      return true;
    }
    if (min && max) {
      return {
        before: new Date(min),
        after: new Date(max),
      };
    }
    if (min) {
      return { before: new Date(min) };
    }
    if (max) {
      return { after: new Date(max) };
    }
  };
  const calenderMenu = [
    {
      name: "Date",
      type: "date",
      action: "setDate",
      icon: CalendarIcon,
      tag: "calender",
      color: "text-primary dark:text-white",
    },
  ];
  const currentYear = new Date().getFullYear();
  const menu = generateMenu(
    calenderMenu,
    {},
    {
      calender: {
        component: () => {
          return (
            <div>
              <DayPicker
                mode="single"
                endMonth={new Date(currentYear+5, 0)}
                
                captionLayout="dropdown"
                 defaultMonth={(dateInputProps?.value ||  value)? new Date(dateInputProps?.value ||  value) : new Date()}
                disabled={handleDisabledState()}
                selected={new Date(dateInputProps?.value || value ||  "")}
                onSelect={(date) => {
                  handleChangeEvent(formatDate(new Date(date! || "")), name);
                  //@ts-ignore
                  //dispatch(toggleDateInputPortal(false))
                  setOpenModel(false);
                }}
                components={{
                  YearsDropdown: CustomYearsDropdown,
                  MonthsDropdown: CustomMonthsDropdown,
                }}
                footer={
                  <Footer
                    handleChangeEvent={handleChangeEvent}
                    name={name}
                    footerOptions={footerOptions}
                    formatDate={formatDate}
                    setOpenModel={setOpenModel}
                  />
                }
              />
            </div>
          );
        },
      },
    },
  );
  const divRef = React.useRef<HTMLDivElement>(null);
  const divRef2 = React.useRef<HTMLDivElement>(null);
  // useOutsideClick(divRef, () => setOpenModel(false));
  const [boundries, setBoundries] = useState<{
    top: number;
    left: number;
  }>({ top: 0, left: 0 });
  useLayoutEffect(() => {
    if (divRef.current) {
      console.log(divRef.current.getBoundingClientRect());

      setBoundries({
        left: Math.round(divRef.current.getBoundingClientRect().x),
        top: Math.round(divRef.current.getBoundingClientRect().y),
      });
    }
  }, [openModel]);
  const dispatch = useDispatch();
  useOutsideClick(
    divRef2,
    () => {
      //@ts-ignore
      // dispatch(toggleDateInputPortal(false))
      setOpenModel(false);
    },
    "mousedown",
    false,
    true,
  );
  const handleTopSize = () => {
    if (window.innerHeight - boundries.top < 400) {
      return Math.round(
        boundries.top - (400 - (window.innerHeight - boundries.top)),
      );
    }
    return boundries.top;
  };
  const handleLeftSize = () => {
    if (window.innerWidth - boundries.left < 350) {
      return Math.min(boundries.left + 50, window.innerWidth - 350);
    }
    return Math.min(boundries.left + 50, window.innerWidth - 350);
  };
  useEffect(() => {
    if (!openModel) {
      const timeOut = setTimeout(() => {
        console.log("hi");

        //@ts-ignore
        dispatch(toggleDateInputPortal(false));
      }, 100);
      return () => clearTimeout(timeOut);
    }
  }, [openModel]);

  return (
    <div className="relative" ref={divRef}>
      <Input
        inputProps={{
          ...dateInputProps,
          type: "text",
          
          readOnly: true,
          placeholder: placeHolder || "date",
          value: dateInputProps?.value || "",
          onClick: () => {
            if (isDisabled) return;
            onClickAction?.();
            //@ts-ignore
            dispatch(toggleDateInputPortal(true));
            setOpenModel(true);
          },
          style: { cursor: "pointer", outline: "none" },
        }}
        customClass={`${isDisabled && "bg-[#f3f3f3] cursor-not-allowed"} ${customClass || ""}`}
         labelStyle={customLabelClass}
        label={label || title || "Date"}
        isRequired={isRequired}
      />
      {openModel &&
        menu &&
        ReactDOM.createPortal(
          <div ref={divRef2}>
            <DropDownBox
              dropDownConfig={menu}
              className={cn(
                `w-[330px]   pr-4  dark:bg-primary font-bold text-primary dark:text-white bottom-[0px] top-auto h-fit`,
                dropDownClass,
              )}
              title=""
              style={{
                zIndex: 999999,
                left: `${handleLeftSize()}px`,
                top: `${handleTopSize()}px`,
              }}
              closeDropDown={() => {}}
            />
          </div>,
          document.body,
        )}
    </div>
  );
}

export default SingleDate;
